module.exports = __webpack_public_path__ + "static/media/pinInputActive.3f82e1c5.svg";